import { FC, useState } from "react";
import Modal from "../../ui/Modal";
import Button from "../../ui/Button";
import { SubmitHandler, useForm } from "react-hook-form";
import Input from "../../ui/Input";
import { BiPlusCircle } from "react-icons/bi";
import { toast } from "react-hot-toast";
import axios from "axios";
import useApi from "../../../hooks/useApi";
import { IToken } from "../../../types/ApiTypes";

interface Props {
  onTokenCreated: (token: IToken) => void;
}

interface InputFields {
  name: string;
}

const TokenModal: FC<Props> = (props) => {
  const [newTokenModalOpen, setNewTokenModalOpen] = useState(false);

  const {register, handleSubmit, formState: {errors}} = useForm<InputFields>({
    shouldUnregister: true
  })

  const {createApiToken} = useApi();

  const onSubmit: SubmitHandler<InputFields> = async (e) => {
    await toast.promise(createApiToken(e.name), {
      loading: 'API Token wird erstellt',
      success: token => {
        if(token) {
          props.onTokenCreated(token);
        }
        setNewTokenModalOpen(false);
        return <span className='text-sm'>API Token wurde erstellt.</span>
      },
      error: (err) => {
        if(axios.isAxiosError(err) && err.response?.data?.error) return err.response.data.error.map((x:{msg:string},idx:number) => (
          <span className='text-sm' key={idx}>Backend Fehler:<br/>{x.msg}</span>
        ));
        else return <span className='text-sm'>Der Token konnte nicht erstellt werden</span>
      }
    })
  }

  return (
    <>
      <Button onClick={() => setNewTokenModalOpen(true)}>Neues Token erstellen</Button>
      <Modal isOpen={newTokenModalOpen} onClose={() => setNewTokenModalOpen(false)} title='Neuen Token erstellen'>
        <form autoComplete='off' className='space-y-4' onSubmit={handleSubmit(onSubmit)}>
          <div>
            <label className="font-semibold">Token Name</label>
            <Input id='name' label='Token name' {...register('name',{required: true, minLength: 4})}/>
            {errors.name && <span className="text-xs text-error-brighter">{errors.name.message || 'Invalid input'}</span>}
          </div>
          <Button type="submit"><BiPlusCircle className="mr-1" /> Erstellen</Button>
        </form>
      </Modal>
    </>
  );
};

export default TokenModal;